import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class LocalizationService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    GetAllItems(query): Promise<any> {
        return this.baseApiFactory.getData<any[]>('/api/Localization', query);
    }

    CreateItem(value): Promise<any> {
        return this.baseApiFactory.post<boolean>('/api/Localization', value);
    }

    SaveChange(values): Promise<any> {
        return this.baseApiFactory.put<boolean>('/api/Localization', values);
    }

    UploadFormData(file: File, langCode: string): Promise<any> {
        return this.baseApiFactory.postFormData<boolean>('/api/Localization/UploadResx', file, {lang: langCode});
    }

    DownloadResx(currentLanguage: string, currentTargetLanguage: string): Promise<any> {
        return this.baseApiFactory.download(`/api/Localization/DownloadResx?reference=${currentLanguage}&lang=${currentTargetLanguage}`, {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            fileName: `EPartner_Text_${currentTargetLanguage}.xlsx`
        });
    }
}

lazyRegister.service('LocalizationService', LocalizationService);

